import * as yup from "yup";
import DataTable from "react-data-table-component";
import api from "@/services/axios.js";
import JoditEditor from "jodit-react";
import Select from "@/shared/components/form/Select.jsx";

export * from "@/utils";

export { api, DataTable, yup, JoditEditor, Select };

export * from "@/services/api";

export * from "@/assets";

export * from "@/shared/components";

export * from "@/shared/stores";
export * from "@/shared/hooks";

export * from "@heroicons/react/24/outline";

export { saveAs } from "file-saver";

export { useForm, Controller } from "react-hook-form";
export { useEffect, useState, useRef, useMemo, useCallback } from "react";
export { initFlowbite, initTooltips, initDropdowns } from "flowbite";
export { yupResolver } from "@hookform/resolvers/yup";
export { baseURL } from "@/services/axios.js";
export { debounce, sumBy, random } from "lodash";

export const formHeaders = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
  onUploadProgress: (progressEvent) => {
    const total = progressEvent.total;
    const loaded = progressEvent.loaded;
    const percentCompleted = Math.round((loaded * 100) / total);
    const el = document.getElementById("progressNumber");
    if (el) el.innerText = percentCompleted + "%";
  },
};

export {
  Link,
  Outlet,
  Navigate,
  useParams,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
